// extracted by css-extract-rspack-plugin
export default {"option":"wGaDq","content":"JVKPb"};